<template>
  <v-app>

    <v-main>
       <router-view></router-view>
    </v-main>
  </v-app>
</template>
<style>
  @import './assets/styles/styles.css';
</style>

<script>
export default {
  name: 'App',
  components: {
  },
  data: () => ({
    //
  }),
};
</script>